<footer>
    <div class="layout footer-layout">
        <div>©2022 Македонски Телеком </div>
    </div>
</footer>